import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';

/**
 * File Management API Service
 */
@Injectable({
    providedIn: 'root'
})
export class FileManagementService extends BaseApiService {

    /**
     * Upload file
     */
    uploadFile(file: File, path?: string): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        if (path) {
            formData.append('path', path);
        }
        
        return this.post<any>('/file-management/upload', formData)
            .pipe(map(response => response.data!));
    }

    /**
     * Download file
     */
    downloadFile(fileId: string): Observable<Blob> {
        return this.get<Blob>(`/file-management/download/${fileId}`)
            .pipe(map(response => response.data!));
    }

    /**
     * Delete file
     */
    deleteFile(fileId: string): Observable<void> {
        return this.delete<void>(`/file-management/delete/${fileId}`)
            .pipe(map(() => undefined));
    }

    /**
     * Get file information
     */
    getFileInfo(fileId: string): Observable<any> {
        return this.get<any>(`/file-management/info/${fileId}`)
            .pipe(map(response => response.data!));
    }

    /**
     * List files
     */
    listFiles(path?: string): Observable<any> {
        const params = path ? { path } : undefined;
        return this.get<any>('/file-management/list', params)
            .pipe(map(response => response.data!));
    }

    /**
     * Create directory
     */
    createDirectory(path: string): Observable<any> {
        return this.post<any>('/file-management/create-directory', { path })
            .pipe(map(response => response.data!));
    }

    /**
     * Delete directory
     */
    deleteDirectory(path: string): Observable<void> {
        return this.delete<void>(`/file-management/delete-directory/${encodeURIComponent(path)}`)
            .pipe(map(() => undefined));
    }
}
